import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    ButtonGroup,
    Modal,
    Button,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    Input,
    FormFeedback
} from 'reactstrap'

import { connect } from 'react-redux';
import {
    zones__destroy,
    zones__updateAttibutes,
    zones_dismissZoneAlert
} from 'redux/actions/zones'


class ZoneEditor extends Component {
    static propTypes = {
        zone: PropTypes.object,
        dispatch: PropTypes.func,
        alert: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            section: null,
            color: null,
            telegram: null,
            updatezone: false
        }
    }

    toggleUpdateZone = () => {
        this.setState({
            updatezone: !this.state.updatezone,
        });
    }
    onZoneNameSubmit = () => {
        if (this.state.section === null) {
            return
        }
        const { dispatch, zone } = this.props
        dispatch(zones__updateAttibutes(zone.id, { section: this.state.section }, 'section'))
    }

    onZoneRemove = () => {
        const { dispatch, zone } = this.props
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Permanently delete the zone and all the corresponding checkpoints',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { dispatch(zones__destroy(zone.id)) }
                },
                {
                    label: 'No'
                }
            ]
        });
    }
    onZoneColorUpdate = () => {
        if (this.state.color === null) {
            return
        }
        const { dispatch, zone } = this.props
        dispatch(zones__updateAttibutes(zone.id, { color: this.state.color }, 'color'))
    }
    onZoneTelegramIdUpdate = () => {
        //console.log(`onZoneTelegramIdUpdate`)
        if (this.state.telegram === null) {
            return
        }
        const { dispatch, zone } = this.props
        dispatch(zones__updateAttibutes(zone.id, { telegramId: this.state.telegram }, 'telegram'))
    }


    render() {
        const { dispatch, alert, zone } = this.props

        let zoneSection = zone.section
        if (this.state.section !== null) {
            zoneSection = this.state.section
        }

        let zoneTelegram = zone.telegramId
        if (this.state.telegram !== null) {
            zoneTelegram = this.state.telegram
        }

        let zoneColor = zone.color
        if (this.state.color !== null) {
            zoneColor = this.state.color
        }

        let sectionInvalid = false
        let sectionValid = false
        if (zone.id === alert.section.id) {
            sectionInvalid = alert.section.invalid
            sectionValid = alert.section.valid
        }
        let sectionMsg = alert.section.message

        let colorInvalid = false
        let colorValid = false
        if (zone.id === alert.color.id) {
            colorInvalid = alert.color.invalid
            colorValid = alert.color.valid
        }
        let colorMsg = alert.color.message

        let telegramInvalid = false
        let telegramValid = false
        if (zone.id === alert.telegram.id) {
            telegramInvalid = alert.telegram.invalid
            telegramValid = alert.telegram.valid
        }
        let telegramMsg = alert.telegram.message

        return (
            <ButtonGroup>
                <Button
                    onClick={this.toggleUpdateZone}
                    color="dark" size="md">
                    <span className="hover-opa">Update Zone{' '}<i className="icon-note"></i></span>
                </Button>{' '}
                <Modal isOpen={this.state.updatezone} toggle={this.toggleUpdateZone} className={'modal-dark'}>
                    <ModalHeader toggle={this.toggleUpdateZone}><span className="h2">Update Zone</span></ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(e) => { e.preventDefault() }}>
                            <FormGroup>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        Zone :
                                    </InputGroupAddon>
                                    <Input
                                        valid={sectionValid}
                                        invalid={sectionInvalid}
                                        value={zoneSection}
                                        onChange={(e) => this.setState({ section: e.target.value })}
                                        onFocus={() => dispatch(zones_dismissZoneAlert(zone.id, 'section'))}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onZoneNameSubmit} color="success">Update</Button>
                                    </InputGroupAddon>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'section'))}
                                        valid className="text-center"
                                        style={{ backgroundColor: 'white' }}>
                                        {sectionMsg}
                                    </FormFeedback>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'section'))}
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}>
                                        {sectionMsg}
                                    </FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                        <Form onSubmit={(e) => { e.preventDefault() }}>
                            <FormGroup>
                                <InputGroup size='sm' style={{ marginTop: '5px' }}>
                                    <InputGroupAddon addonType="prepend">Telegram ID</InputGroupAddon>
                                    <Input
                                        valid={telegramValid}
                                        invalid={telegramInvalid}
                                        onChange={(e) => this.setState({ telegram: e.target.value })}
                                        value={zoneTelegram}
                                        onFocus={() => dispatch(zones_dismissZoneAlert(zone.id, 'telegram'))}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onZoneTelegramIdUpdate} color="success">Update</Button>
                                    </InputGroupAddon>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'telegram'))}
                                        valid className="text-center"
                                        style={{ backgroundColor: 'white' }}>
                                        {telegramMsg}
                                    </FormFeedback>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'telegram'))}
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}>
                                        {telegramMsg}
                                    </FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                        <Form onSubmit={(e) => { e.preventDefault() }}>
                            <FormGroup>
                                <InputGroup size='sm' style={{ marginTop: '5px' }} className="w-50 mx-auto">
                                    <InputGroupAddon addonType="prepend">Color</InputGroupAddon>
                                    <Input
                                        valid={colorValid}
                                        invalid={colorInvalid}
                                        onChange={(e) => this.setState({ color: e.target.value })}
                                        onFocus={() => dispatch(zones_dismissZoneAlert(zone.id, 'color'))}
                                        type='color'
                                        value={zoneColor}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onZoneColorUpdate} color="success">Update</Button>
                                    </InputGroupAddon>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'color'))}
                                        valid className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {colorMsg}
                                    </FormFeedback>
                                    <FormFeedback
                                        onClick={() => dispatch(zones_dismissZoneAlert(zone.id, 'color'))}
                                        className="text-center"
                                        style={{ backgroundColor: 'white' }}
                                    >
                                        {colorMsg}
                                    </FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                </Modal>

                <Button
                    onClick={this.onZoneRemove}
                    color="primary"
                    size="md"
                >
                    <span className="hover-opa">Remove Zone{' '}<i className="icon-trash"></i></span>
                </Button>{' '}
            </ButtonGroup>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        dispatch: store.dispatch,
        alert: store.zones.alert
    }
}
export default connect(
    mapStateToProps
)(ZoneEditor)


// WEBPACK FOOTER //
// ./src/components/features/ZoneEditor/ZoneEditor.js